<template>

    <div class="error-page">
        <h2 class="headline text-yellow"> 404</h2>

        <div class="error-content" style="padding:20px 0 0 20px;">
            <h3><i class="fa fa-warning text-yellow"></i> Oops! Page not found.</h3>

            <p>
                We could not find the page you were looking for.
                Meanwhile, you may <router-link :to="{name:'dashboard'}">return to dashboard</router-link>.
            </p>
        </div>
    </div>

</template>

<script>

export default {

    metaInfo: {
        title:'Page not found',
    },

    name:'ErrorsPageNotFound',

}

</script>
